import { Temporal } from '@js-temporal/polyfill';

const instance = Temporal.Now.instant();

function getOffset(timeZone: string): number {
  const tz = Temporal.TimeZone.from(timeZone);
  return tz.getOffsetNanosecondsFor(instance);
}

function getFormattedOffset(timeZone: string): string {
  // полифил говорит что может ещё другой тип вернуться, но в спецификации только один тип
  const tz = Temporal.TimeZone.from(timeZone) as Temporal.TimeZone;
  return tz.getOffsetStringFor(instance);
}

export const DateTimeZoneHelper = {
  getOffset,
  getFormattedOffset
};
